import styled from 'styled-components'

import { Button } from '@src/components/Button/Button'
import { LocationSVG } from '@src/components/SVGS/LocationSVG'
import { breakpoints } from '@src/constants/breakpoints'

export const OuterContainer = styled.div<{ $alignment?: string }>`
  display: flex;
  flex-direction: column;
  align-items: ${props => {
    switch (props.$alignment?.toLowerCase()) {
      case 'left':
        return 'flex-start'
      case 'right':
        return 'flex-end'
      case 'center':
      default:
        return 'center'
    }
  }};

  @media (min-width: ${breakpoints.tabletMisc}px) {
    flex-direction: column;
  }
`

export const Container = styled.form<{ resultsOpen?: boolean }>`
  position: relative;
  box-sizing: border-box;
  padding: 8px;
  border-radius: ${({ resultsOpen }) => (resultsOpen ? '8px 8px 0 0' : '8px')};
  width: 100%;
  border: 2px solid transparent;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  background-color: #fff;
  margin: 0 0 32px 0;
  border-bottom: ${({ resultsOpen }) =>
    resultsOpen ? 'none' : '2px solid transparent'};

  &:focus-within {
    border-color: ${({ theme }) => theme.colors.brand};
  }

  @media (min-width: ${breakpoints.phablet}px) {
    flex-direction: row;
    max-width: 600px;
  }
`

export const SearchHeadContainer = styled.div`
  position: relative;
  width: 100%;

  @media (min-width: ${breakpoints.phablet}px) {
    max-width: 600px;
  }
`

export const ShowEverywhereText = styled.button`
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
  color: ${({ theme }) => theme.colors.heroText};
  border: none;
  background: none;
  padding: 0;
  text-decoration: underline;
  text-shadow: 0px 1px 1px rgba(0, 0, 0, 0.3);

  &:hover {
    text-decoration: none;
  }
`

export const TextHelp = styled.div`
  color: ${({ theme }) => theme.colors.heroText};
  font-size: 14px;
  white-space: pre-wrap;
  font-weight: 700;
  text-shadow: 0px 1px 1px rgba(0, 0, 0, 0.3);
`

export const HelpTextContainer = styled.div`
  flex-direction: row;
  display: flex;
  justify-content: center;
  margin: 0 0 16px 0;
`

export const Input = styled.input`
  box-sizing: border-box;
  height: 100%;
  border: none;
  padding: 8px 42px 8px 0px;
  outline: none;
  font-size: 18px;
  font-weight: 400;
  width: 100%;
  text-align: center;
  @media (min-width: ${breakpoints.phablet}px) {
    text-align: left;
    width: 50%;
    padding: 8px 0px 8px 16px;
  }
  min-width: 180px;
`

export const SearchButton = styled(Button)`
  padding: 0px 16px;
  width: 100%;
  @media (min-width: ${breakpoints.phablet}px) {
    width: auto;
  }
`

export const LocationButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  background-color: transparent;
  margin-bottom: 8px;
  @media (min-width: ${breakpoints.phablet}px) {
    margin: 0;
  }
`

export const LocationButton = styled.button`
  border: none;
  cursor: pointer;
  height: max-content;
  padding: 0px;
  background-color: transparent;
  padding: 2px 0 0 2px;
`

export const StyledLocationSVG = styled(LocationSVG)`
  height: 42px;
  width: 42px;
  padding: 0px;
  cursor: pointer;

  .circle {
    fill: #fff;
    stroke: #fff;
  }

  .arrow {
    fill: ${({ theme }) => theme.colors.brand};
  }

  .circle,
  .arrow {
    transition: 0.2s ease;
    transition-property: fill, stroke;
  }

  &:hover {
    .circle {
      fill: ${({ theme }) => theme.colors.brand};
      stroke: ${({ theme }) => theme.colors.brand};
    }

    .arrow {
      fill: #fff;
    }
  }
`

export const SpinnerContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 16px 0;
`

export const ResultsOuterContainer = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  top: calc(100% - 32px);
  background-color: #fff;
  z-index: 20;
  border: 2px solid ${({ theme }) => theme.colors.brand};
  border-radius: 0 0 8px 8px;
  box-shadow: 0 8px 6px -3px rgba(0, 0, 0, 0.1);
  max-height: 40vh;
  overflow-y: auto;
  text-align: left;
  border-top: 0;
  width: 100% @media (max-width: ${breakpoints.tablet}px) {
    max-height: calc(100dvh - 200px);
  }
`

export const ResultsOption = styled.button`
  border: none;
  background-color: transparent;
  text-align: left;
  padding: 14px 16px;
  cursor: pointer;
  font-size: 16px;
  width: 100%;

  &:hover {
    background-color: ${({ theme }) => theme.colors.brand};
    color: #fff;
  }

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.colors.brand};
    outline-offset: -2px;
  }
`
